var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseV2 = function SvgCloseV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.292 16a.309.309 0 0 1-.206-.084.28.28 0 0 1 0-.404L15.51.086a.28.28 0 0 1 .404 0 .28.28 0 0 1 0 .404L.49 15.916A.26.26 0 0 1 .292 16Z",
    fill: "#121215"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.716 16a.309.309 0 0 1-.206-.084L.086.49a.28.28 0 0 1 0-.404.28.28 0 0 1 .404 0l15.424 15.426a.28.28 0 0 1 0 .404.25.25 0 0 1-.198.084Z",
    fill: "#121215"
  })));
};
export default SvgCloseV2;